(() => {
    const scrollTopBtn = document.getElementById("scrollTopBtn");

    let ticking = false;
    function toggleScrollBtn() {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const docHeight = document.documentElement.scrollHeight - window.innerHeight;

        const scrolledPercent = (scrollTop / docHeight) * 100;

        scrollTopBtn.style.display = scrolledPercent >= 40 ? "flex" : "none";
        ticking = false;
    }

    window.addEventListener("scroll", () => {
        if (!ticking) {
            ticking = true;
            requestAnimationFrame(toggleScrollBtn);
        }
    }, { passive: true });

    scrollTopBtn.addEventListener("click", () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    });

})();